import { useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import Typography from "core/components/Typography";
import OrgSegmentSwitcher from "modules/admin/OrgSegmentSwitcher";
import Link from "core/components/Link";

const OrganizationSegmentSwitcherPage = () => {
  const location = useLocation();

  return (
    <div style={{ maxWidth: "450px", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-24px",
          left: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Link
          to={`..`}
          relative="path"
          state={{ from: "route" }}
          style={{
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          General
        </Link>

        <FontAwesomeIcon
          icon={faChevronRight}
          color="#3e3e3c"
          fontSize="12px"
        />

        <div style={{ fontSize: "14px", color: "#3E3E3C" }}>
          Segment Switcher
        </div>
      </div>

      <Typography variant="h2">Customer Segment Switcher</Typography>
      <Typography variant="p">
        Changing your customer segment will result in a new deployment of the
        product license.
      </Typography>

      <OrgSegmentSwitcher />
    </div>
  );
};

export default OrganizationSegmentSwitcherPage;
